export default "__VITE_ASSET__sifq$mBb__"